const ContentNavigation = ({ bodyFromContent: initialBodyFromContent, contentType: initialContentType }) => {
    return {
        allowedTagsOnSidebar: { h2: 'H2' },
        nodesToWrap: ['TABLE'],
        bodyFromContent: initialBodyFromContent,
        contentType: initialContentType,
        items: [],

        init(){
            window.addEventListener('resize', () => this.handleResponsiveness());

            this.items = this.getHeaders();
        },

        /**
         * Core functions
         */
        getItemData(text = '', link = '') {
            return  ({ item: { text, link } });
        },

        getAdditionalHeaders(headers) {
            const additional = [
                this.checkForElementExistence('related-tools', 'Related Tools'),
                this.checkForElementExistence('references', 'References'),
            ];

            let specify = [...headers];

            return [...specify, ...additional].filter(Boolean);
        },

        checkForElementExistence(element, text) {
           return document.getElementById(element) ? this.getItemData(text, `#${element}`) : undefined
        },

        getHeaders() {
            const { headers: nodeList, body } = this.getParsedContent();

            let headers = [];

            document.getElementById('content-body').innerHTML = body;

            this.handleResponsiveness();

            window.dispatchEvent(new CustomEvent('content-body-loaded', { detail : { body } }));

            nodeList.forEach((header,i) => {
                const link = `#${header.getAttribute('id')}`
                const text = header.innerText;
                const item = this.getItemData(text, link);

                headers.push({ ...item });
            });

            headers = this.getAdditionalHeaders(headers);

            headers.map((header, index) => {
                header.item.topic = this.romanizeNumber(index + 1) + '.';

                return header;
            });

            return headers;
        },

        getParsedContent() {
            const html = new DOMParser().parseFromString(this.bodyFromContent, 'text/html');

            const allowedNodes = Array.prototype.map
                .call(html.body.childNodes, (node) => Object.values(this.allowedTagsOnSidebar).includes(node.tagName) && node)
                .filter(Boolean);

            const headers = allowedNodes.map((node) => {
                const type = node.tagName.includes(this.allowedTagsOnSidebar.h2) ? 'topic' : 'subtopic';
                node.setAttribute('id', this.generateTopicId(node.innerText, type));

                return node;
            });

            const body = html.documentElement.outerHTML;

            return { body, headers };
        },

        romanizeNumber(num) {
            const lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
            let roman = '', i;

            for ( i in lookup ) {
                while ( num >= lookup[i] ) {
                roman += i;
                num -= lookup[i];
                }
            }

            return roman;
        },

        generateTopicId(str = '', type = 'topic') {
            str = str.replace(/^\s+|\s+$/g, '').toLowerCase();

            const from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
            const to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";

            for (let i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

            return `${type}-${str}`;
        },

        handleResponsiveness() {
            const body = document.getElementById('content-body');

            Array.prototype.map
                .call(body.childNodes, (node) => {
                    if(Object.values(this.nodesToWrap).includes(node.tagName) && (node.clientWidth > body.clientWidth || body.clientWidth <= 640)){
                        const hasMoreColumns = (
                            node?.rows[0]?.cells?.length > 1 ||
                            node?.rows[1]?.cells?.length > 1 ||
                            node?.rows[2]?.cells?.length > 1
                        ) ?? false;
                        node.outerHTML = `<div class="wrapped-element ${hasMoreColumns ? 'multiple-columns' : ''}">${node.outerHTML}</div>`
                    }
                });
        },

        /**
         * Common functions
         */
        handleQuerySelector(href) {
            let element = null;

            try {
                element = document.querySelector(href);
            } catch (e) {
                console.error(e)
            }

            return element;
        },

        handleNearestLink({target}) {
            const link = target.lastElementChild || target.nextElementSibling;

            link?.tagName === 'A' && link.dispatchEvent(new CustomEvent('click'));
        },

        handleSmoothScroll(e) {
            e.preventDefault();

            const targetElementId = e.target.getAttribute('href');
            const targetElement = this.handleQuerySelector(targetElementId);
            const position = targetElement?.getBoundingClientRect();

            const offset = 220;

            window.scrollTo(position?.left, position?.top + window.scrollY - offset);
        },
    };
};

export default ContentNavigation;
